'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarHeader from 'ContentEditorUI/components/sidebar/SidebarHeader';
import SlidingPanelWrapper from 'ContentEditorUI/components/sidebar/SlidingPanelWrapper';
import { TransitionGroup } from 'react-transition-group';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class Sidebar extends Component {
  componentDidMount() {
    this.updateParentContainerClasses();
  }
  getSidebarWrapperElement() {
    if (!this.sidebarWrapperElement) {
      this.sidebarWrapperElement = document.querySelector('.contentEditor-sidebar');
    }
    return this.sidebarWrapperElement;
  }
  getElementToUpdate() {
    if (!this.element) {
      this.element = document.querySelector('.editor-pane-container');
    }
    return this.element;
  }
  addClassName(classname) {
    const element = this.getElementToUpdate();
    if (element) {
      element.classList.add(classname);
    }
  }
  removeClassName(classname) {
    const element = this.getElementToUpdate();
    if (element) {
      element.classList.remove(classname);
    }
  }
  updateParentContainerClasses() {
    this.addClassName('sidebar-is-expanded');
  }
  renderEditPanel() {
    const {
      activePanel,
      isReadOnlyMode,
      isOpen,
      children
    } = this.props;
    return /*#__PURE__*/_jsx(SlidingPanelWrapper, {
      isReadOnlyMode: isReadOnlyMode,
      isOpen: isOpen,
      transitionName: 'sidebar-panel-slide-in',
      transitionSpeed: 320,
      activePanel: activePanel,
      onClose: this.props.onClose,
      children: children
    }, "sliding-edit-panel");
  }
  render() {
    const {
      isOpen
    } = this.props;
    const sidebarClasses = 'expanding-sidebar clean-lines-styles' + (isOpen ? " is-expanded" : "");
    return /*#__PURE__*/_jsx("div", {
      className: sidebarClasses,
      children: /*#__PURE__*/_jsxs("div", {
        className: "sidebar-content",
        id: "inpage-sidebar-container",
        children: [/*#__PURE__*/_jsx(SidebarHeader, {}), /*#__PURE__*/_jsx(TransitionGroup, {
          className: "sidebar-transition-group",
          component: "div",
          children: this.renderEditPanel()
        })]
      })
    });
  }
}
Sidebar.propTypes = {
  children: PropTypes.node.isRequired,
  activePanel: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired
};